import { lazy } from 'react';


export const Advantages = lazy(() => import('./Advantages'));
